import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { TableColumn } from '@ui/aos-lib';
import { Report } from 'src/app/pages/reporting/reports.types';
import { ReportsService } from 'src/app/pages/reporting/services/reports.service';

@Component({
  selector: 'aos-report-name-column',
  template: `
    <button
      class="report-name-column__link"
      (click)="openReport()"
    >
      {{ item().title }}
    </button>
  `,
  styleUrl: './report-name-column.component.scss',
  host: { class: 'full-width' },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportNameColumnComponent {
  readonly item = input.required<Report>();
  readonly column = input.required<TableColumn>();

  private readonly router = inject(Router);
  private readonly reportsService = inject(ReportsService);

  protected openReport(): void {
    const report = this.item();

    this.router.navigate(['reports', report.id], {
      state: { report, guestToken: this.reportsService.guestToken() }
    });
  }
}
